import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MIN_RESOLUTION_FOR_DESKTOP } from '../../config/constants';

@Injectable()

export class CollapseService {
  collapse = new BehaviorSubject(false);

  get collapse$() {
    return this.collapse.asObservable();
  }

  getCollapseStatus() {
    return this.collapse.getValue();
  }

  toggleCollapse() {
    let collapse = !this.collapse.getValue();
    if (window.innerWidth >= MIN_RESOLUTION_FOR_DESKTOP) {
      collapse = false;
    }
    this.collapse.next(collapse);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/visual/collapse.service.ts